module.exports = __webpack_public_path__ + "media/images/social_icons/googleplus-dc591b685e15ece3af46594223188bda.png";